import { ResponseTypeReverse, AnswerEvaluationReverse } from 'appConsts';

const formatAnswerForCommand = answer => ({
  ...answer,
  answerEvaluation: AnswerEvaluationReverse[answer.answerEvaluation],
  responseType: ResponseTypeReverse[answer.responseType]
});

export default formatAnswerForCommand;
